import axios from "axios";
export type Panel = {
  watt: string;
  voc: number;
  isc: number;
  price: number;
  name: string;
  efficiency: number;
};

export type Inverter = {
  watt: string;
  name: string;
  price: number;
  efficiency: number;
  maxInputVoltage: number;
  minInputVoltage: number;
  maxInputCurrent: number;
};

export type Battery = {
  batteryName: string;
  batteryPower: number;
  batteryPrice: number;
  betteryAh: number;
  batteryVoltage: number;
  batteryType: string;
  batteryCycle: number;
};
export interface CompanyData {
   companyName: string;
    isActive: boolean;
    duration: string;
    phoneNumber: string;
    email: string;
    address: string;
     panel?: Panel[];
    inverter?: Inverter[];
    battery?: Battery[];

}

interface CompanyResponse {
    id: string;
    name: string;
    address?: string;
    email?: string;
    phone?: string;
    [key: string]: any;
}

export const addCompany = async (companyData: CompanyData): Promise<CompanyResponse> => {
    try {
        const response = await axios.post<CompanyResponse>(
            `${process.env.REACT_APP_API_URL}/create-company`,
            companyData
        );
        return response.data;
    } catch (error) {
        console.error("Error adding company:", error);
        throw error;
    }
};
export const updateCompany = async (companyId:number|string, companyData:CompanyData) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/update-company/${companyId}`,
      companyData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating company:", error);
    throw error;
  }
}
export const deleteCompany = async (companyId:string) => {
   
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/delete-company/${companyId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting company:", error);
    throw error;
  }
}
export const getCompany = async (companyId:number) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/company/${companyId}`
    );
    return response.data;
  } catch (error) {
    // console.error("Error fetching company data:", error);
    throw error;
  }
}
export const getCompanies = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-all-companies`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching companies data:", error);
    throw error;
  }
}
export const getCompanyById = async (companyId:number) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/company/${companyId}`
    );
    return response.data;
  } catch (error) {
    // console.error("Error fetching company data:", error);
    throw error;
  }
}
export const getCompanyByName = async (companyName:string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-company-by-name/${companyName}`
    );
    return response.data;
  } catch (error) {
    // console.error("Error fetching company data:", error);
    throw error;
  }
}


